import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { StateItem } from '../../state-item';
import { IPage, IPageInfo } from '../page.model';
import { RestaurantGoodsApi } from './restaurant-goods.api';
import { IRestaurantGoods } from './restaurant-goods.model';

@Injectable()
export class RestaurantGoodsPageStateItem extends StateItem<IPage<IRestaurantGoods> | null> {
  private readonly restaurantGoodsApi = inject(RestaurantGoodsApi);

  private mrhstId?: number;

  constructor() {
    super(null);
  }

  loadPage(mrhstId: number): void {
    if (this.mrhstId !== mrhstId) {
      this.mrhstId = mrhstId;

      this.restaurantGoodsApi
        .findPage({
          'mrhst.id': mrhstId,
          activeFl: true,
        })
        .subscribe((page) => {
          this.setValue(page);
        });
    }
  }

  get page$(): Observable<IPage<IRestaurantGoods> | null> {
    return this.value$;
  }

  get page(): IPage<IRestaurantGoods> | null {
    return this.value;
  }

  get list$(): Observable<IRestaurantGoods[] | null> {
    return this.value$.pipe(map((page) => page?.content ?? null));
  }

  get list(): IRestaurantGoods[] | null {
    return this.value?.content ?? null;
  }

  get pageInfo$(): Observable<IPageInfo | null> {
    return this.value$.pipe(map((page) => page?.page ?? null));
  }

  get pageInfo(): IPageInfo | null {
    return this.value?.page ?? null;
  }
}
